import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles((theme) => {
  return {
    camelCase: {
      textTransform: "capitalize",
    },
    divider: {
      marginBottom: 15,
    },
    submitButton: {
      marginRight: 10,
    },
    areaBox: {
      padding: '10px',
      height: "calc(100vh - 150px)",
      overflowY: 'auto',
      overflowX: 'hidden'
    },
  };
});

export default styles;
